import IconCart from '!svg-react-loader?!images/icons/icon-cart.svg';
import IconClose from '!svg-react-loader?!images/icons/icon-close.svg';
import 'styles/cart/cart-trigger.scss';

import React from 'react';
import classNames from 'classnames';
import Transition from 'react-transition-group/Transition';

import Button from 'common/components/Button';
import CartIcon from './CartIcon';
import propTypes from 'propTypes';

export default class CartTrigger extends React.Component {
  static propTypes = {
    totalItems: propTypes.number.isRequired,
  };

  handleTriggerClick = () => {
    this.props.toggleCartVisibility();
  };

  // react does not own the overlay dom element so
  // we have to use a method like this to work-around that
  componentDidMount = () => {
    this.closeTargetEl = document.getElementsByClassName('header__overlay')[0];
    this.closeTargetEl.addEventListener('click', this.onHeaderClick);
  };

  componentWillUmount = () => {
    this.closeTargetEl.removeEventListener('click', this.onHeaderClick);
    this.closeTargetEl = null;
  };

  onHeaderClick = () => {
    if (this.props.isOpen) {
      this.handleTriggerClick();
    }
  };

  render() {
    const { totalItems, isOpen } = this.props;

    const rootClassNames = classNames('CartTrigger', {
      'CartTrigger--open': isOpen,
      'CartTrigger--closed': !isOpen,
    });

    return (
      <div className={rootClassNames} onClick={this.handleTriggerClick}>
        <CartIcon isOpen={isOpen} totalItems={totalItems} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/CartTrigger.js